import { type FilterValues } from "components/filters/FilterContext";
import { mapExtractorSessionLifeCycleFilterToInstruction, mapOwnersFilterToInstruction, mapResponseToExtractorSessionLifeCycleFilter, mapResponseToOwnerFilter } from "components/filters/mappingUtils";

export const mapFilterValuesToInstruction = (
  filterSet: server.dto.FilterSets,
  filter: FilterValues,
  page: number,
  perPage: number
): server.dto.PaginatedExtractorSessionInstruction => ({
  ownerUserIds: mapOwnersFilterToInstruction(filter.owners),
  lifeCycles: mapExtractorSessionLifeCycleFilterToInstruction(filter.extractorSessionLifeCycle),
  page,
  perPage,
  cache: filterSet
});

export const mapResponseToFilterValues = (
  response: server.dto.ListExtractorSessionFilters,
  _: FilterValues
): Partial<FilterValues> => ({
  owners: mapResponseToOwnerFilter(response.ownerUsers),
  extractorSessionLifeCycle: mapResponseToExtractorSessionLifeCycleFilter(response.lifeCycles)
});
